import { faPause, faPlay, faArrowAltRight,faAngleLeft } from '@fortawesome/pro-solid-svg-icons';
import {faTrashUndo, } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import SendVox from "./send";
import { reRecordButton } from '../../utils/alt-tags';

export const Playback = styled.span`
    max-height: 4rem;
    max-width: 4rem;

    svg {
        height: inherit;
    }

    ${props => props.size && css`
        svg {
            height: 100%;
            width: 100%;
        }
    `}
`;

const Previous = styled(Playback)`
  position: ${(props) => props.sendVox ? 'absolute' : ''} ;
  left: ${(props) => props.sendVox ? '1.5rem' : ''} ;
  color: #2e394f;
`;

export const DoPlay = styled(Playback)`
    color: #2e394f;
    cursor: pointer;
`;
const TrashIcon = styled(FontAwesomeIcon)`
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 15px;
  color: #2E394F;
  margin-right: ${(props)=> props.rightmargin === 'true' ? '7px' : ''};
`;
export const PlayButtons= styled.div`
   align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;
  
  .right{
  visibility: hidden;
   }
`


export const Back = ({ onBack, size, sendVox }) => (
    <Previous onClick={onBack} sendVox={sendVox}>
        <TrashIcon icon={faAngleLeft} rightmargin="true"></TrashIcon>
        <TrashIcon  icon={faTrashUndo} title={reRecordButton} />
    </Previous>
)

export const Play = ({ isPlaying, onPlay, size }) => (
    // !isMobile.iOS() ? (
    <DoPlay onClick={onPlay}><FontAwesomeIcon size={size} icon={isPlaying ? faPause : faPlay}  className="right" /></DoPlay>
    // ) : null
)

export default class PlaybackButton extends Component {
    static propTypes = {
        onBack: PropTypes.func,
        onPlay: PropTypes.func,
        onForward: PropTypes.func,
        isPlaying: PropTypes.bool
    }

    render() {
        const { onBack, onPlay, onForward, isPlaying, size, common ,
            micPermission , sendVox, processing, title } = this.props;
        return (
            <PlayButtons>
                {onBack && <Back size={size} onBack={onBack} sendVox={sendVox} />}
                {onForward && <SendVox common={common} size={size} icon={faArrowAltRight} onClick={onForward}
                                       micPermission={micPermission} processing={processing} title={title}/>
                // <Hexagon common={common} size={size} icon={faArrowAltRight} onClick={onForward} micPermission={micPermission}/>
                }
                <Play size={size} isPlaying={isPlaying} onPlay={onPlay}/>
            </PlayButtons>
        )
    }
}
